import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "app/client";

export type Theme = {
  id: string,
  primaryColor: string;
  secondaryColor: string;
  logoFile: {
    id: string,
    fileName: string
  }
}

export const fetchUserTheme = createAsyncThunk(
  '/backoffice/themes/themeByCourtierId',
  async (): Promise<Theme> => {
    const response = (await client.get(`/backoffice/themes`))?.data
    return response;
  }
)
